module.exports = __webpack_public_path__ + "402547f8246bc1d434be9b97ed199f68.fbx";